import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CreateTreeLevelDialogComponent } from '../create-tree-level-dialog/create-tree-level-dialog.component';
import { Design } from 'src/app/shared/models/design.model';
import { TreeNode } from 'primeng/api';
import { StorageKeys, StoreService } from 'src/app/core/services/store.service';
import { mergeRecentDesigns, rememberRecentDesign } from './recent-designs.helper';

@Component({
    selector: 'app-well-explorer-header',
    templateUrl: './well-explorer-header.component.html',
    styles: [],
    providers: [DialogService],
    standalone: false
})
export class WellExplorerHeaderComponent implements OnChanges, OnInit {
  private _recentDesignsLoaded = false;

  @Input()
  public isAdmin : boolean;

  @Input() isGlobalAdmin: boolean;

  @Output()
  public closeSidenav: EventEmitter<string>;

  @Output()
  public designUpdated: EventEmitter<TreeNode>;

  @Output()
  public companyAdded: EventEmitter<{levelData: {id:string, name: string}, level:string}>;

  @Output()
  public refreshWellExplorerEvent: EventEmitter<string>;

  @Input()
  public design: Design;

  @Input()
  public recentDesignSelection: Design | null;

  public designs: Design[] = [];

  @Input()
  public allDesigns: Design[] = [];

  public selectedDesign: any;

  constructor(
    public _dialogService: DialogService,
    private _store: StoreService) {
    this.companyAdded = new EventEmitter();
    this.closeSidenav = new EventEmitter();
    this.designUpdated = new EventEmitter();
    this.refreshWellExplorerEvent = new EventEmitter();
  }

  async ngOnInit(): Promise<void> {
    const savedDesigns = await this._store.get<Design[]>(StorageKeys.RECENT_DESIGNS);
    this.designs = mergeRecentDesigns([
      ...this.designs,
      ...(Array.isArray(savedDesigns) ? savedDesigns : [])
    ], this.design?.id);
    this._recentDesignsLoaded = true;
    await this.persistRecentDesigns();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['design'] && this.design?.id) {
      this.designs = mergeRecentDesigns(this.designs, this.design.id);
    }

    if (changes['recentDesignSelection'] && !changes['recentDesignSelection'].firstChange && this.recentDesignSelection?.id) {
      this.designs = rememberRecentDesign(this.designs, this.recentDesignSelection, this.design?.id);
    }

    if (this._recentDesignsLoaded && (changes['design'] || changes['recentDesignSelection'])) {
      void this.persistRecentDesigns();
    }
  }

  public updateDesign(event: { value: Design }) {
    const design = event.value;
    const selectedDesign: TreeNode = {
      data: {
        id: design.id,
        name: design.name,
        level: 'designs'
      }
    }
    this.designUpdated.emit(selectedDesign);
    this.selectedDesign = [];
  }

  private async persistRecentDesigns(): Promise<void> {
    await this._store.set(StorageKeys.RECENT_DESIGNS, this.designs);
  }

  public collapseSidenav() {
    this.closeSidenav.emit("close");
  }

  public refreshWellExplorer() {
    this.refreshWellExplorerEvent.emit(this.design.id);
  }

  public async addCompany() {
    const dialogReference = this._dialogService.open(CreateTreeLevelDialogComponent, {
      data: {
        level: 'companies'
      },
      header: 'Create a New Company',
      width: '400px'
    });

    dialogReference.onClose.subscribe((levelData : {name: string}) => {
      if (levelData) {
        this.companyAdded.emit({levelData: {id: null, name: levelData.name}, level: 'companies'});
      }
    });
  }
}
